import React, { useEffect, useState } from "react";
import { CheckboxList, Item as ItemT } from "../../../common/formFields/CheckboxList";
import "../../../common/formFields/FormField.scss";
import {
    SensitiveInfoRelease,
    SensitiveInfo as SensitiveInfoModel,
    SensitiveInfoType
} from "../../../models/transaction";

type Item = ItemT<SensitiveInfoType>;

export interface SensitiveInfoUpdate {
    readonly updatedItemId: SensitiveInfoType,
    readonly checked: boolean,
}

interface SensitiveInfoProps {
    data: readonly SensitiveInfoModel[],
    onChange?: (updates: readonly SensitiveInfoUpdate[]) => void,
    errorMsg?: string
}

function SensitiveInfo(props: SensitiveInfoProps) {
    
    const items: Item[] = props.data.map(item => ({
        id: item.id,
        state: item.stateID,
        label: item.name,
    }));
    const [checkboxKey, setCheckboxKey] = useState(0);

    const allowAll = props.data.every(item => item.stateID == SensitiveInfoRelease.Authorized);
    const allowNone = props.data.every(item => item.stateID == SensitiveInfoRelease.Prohibited);

    const onChange = (updatedItemId: SensitiveInfoType, checked: boolean) => {
        props.onChange?.([{updatedItemId, checked}]);
    }

    const clickSetAll = (state: boolean) => {

        const updatedItems = props.data.map(item => ({
            updatedItemId: item.id,
            checked: state,
        } as SensitiveInfoUpdate)
    )
       items.map(item => ({
            ...item,
            state: state ? SensitiveInfoRelease.Authorized : SensitiveInfoRelease.Prohibited,
        } as Item));
        
        props.onChange?.(updatedItems);
    }

    return (
        <div id="sensitiveinfo">
            <div className="new-panel-header section-headers">
                Sensitive Information
            </div>
            <div className="new-panel-body panel-body sensitive-information-accordion">
                <div className="sensitive-info-header">
                    <div className="sensitive-info-question">
                        Review the records and check for any information on the
                        following disease/conditions. Does the patient record
                        contain any reference or information below:
                    </div>
                </div>
                {props.errorMsg && <div className="error-message Phi-text rtr-alert-icon-after">
                    {props.errorMsg}
                </div>}
                <div className={"sensitive-Info-inner" + (props.errorMsg ? " inputError" : "")}>
                    <div className="sensitiveInfoButtonContainer">
                        <button
                            className={"btn sensitiveInfoButton allowAll" + (allowAll ? " sensInfoActive" : "")}
                            onClick={() => clickSetAll(true)}
                        >
                            Authorize the disclosure of ALL sensitive information
                        </button>
                        <button
                            className={"btn sensitiveInfoButton allowNone" + (allowNone ? " sensInfoActive" : "")}
                            onClick={() => clickSetAll(false)}
                        >
                            DO NOT authorize the disclosure of ANY sensitive information
                        </button>
                    </div>
                    <CheckboxList
                        key={checkboxKey}
                        items={items}
                        checkboxHeader="INCLUDE"
                        labelHeaders={["CATEGORY"]}
                        onChange={onChange}
                        className="checkboxSection"
                    />
                </div>
            </div>
            <div className="important-msg">
                <b>Important:</b> There is an increased risk of an inappropriate
                release and/or a HIPAA violation if this information is released
                without additional authorization or documentation.
            </div>
        </div>
    )
}

export default SensitiveInfo
